module.exports = __webpack_public_path__ + "img/NHWBCarousel_work.36062724.jpg";